module.exports = __webpack_public_path__ + "static/media/img-benefit-bonus-mobile@2x.c506f4ae.png";